import React from 'react';
import {
  Container,
  Input,
  H3,
  Avatar,
  Button,
  Text,
  Flex,
} from '@erecruit/ui-kit';
import { connect } from 'react-redux';
import { RootState } from '../../../redux/reducers';

const ProfileSettings: React.FunctionComponent<{
  email: string;
  firstName: string;
}> = ({ email, firstName }) => {
  const firstNameLetter = firstName?.substr(0, 1);
  return (
    <Container background="pageSecondary" style={{ width: '50%' }}>
      <Container background="pageSecondary" padding={4}>
        <H3>Photo</H3>
        <Text color="bodySecondary">Personalize your account</Text>
      </Container>
      <Flex padding={4}>
        <Flex style={{ width: 80 }} align="center" direction="column">
          <Avatar size="large">{firstNameLetter}</Avatar>
        </Flex>
        <Flex direction="column" justify="center">
          <Text padding={[0, 0, 2, 0]} color="bodySecondary">
            Minimum 300x300px
          </Text>
          <Container background="pageSecondary" gutter={4}>
            <Button>Upload photo</Button>
            <Button>Take a photo</Button>
          </Container>
        </Flex>
      </Flex>
      <Container background="pageSecondary" padding={4} divider="top">
        <H3 padding={[2, 0]}>Email</H3>
        <Input value={email} disabled />
      </Container>
      <Container background="pageSecondary" padding={4} divider="top">
        <H3 padding={[2, 0]}>Password</H3>
        <Input type="password" value="test123" disabled />
      </Container>
    </Container>
  );
};

export default connect((state: RootState) => ({
  email: state.oidc.user?.profile.name,
  firstName: state.oidc.user?.profile.erecruit_first_name,
}))(ProfileSettings);
